/**
 * Constants for adAccount filter
 * Separated to break circular dependency between index.js and checkbox/index.js
 */

export const ALL_AD_ACCOUNTS_KEY = 'filter_all';
